import React from "react";
import { Card, CardHeader, CardBody } from "shards-react";

export default class CheckAnomaly extends React.Component {
  render() {
    return (
      <Card small className="mb-4">
        <CardHeader className="border-bottom">
          <h6 className="m-0">{this.props.title}</h6>
        </CardHeader>
        <CardBody
          className="p-0 overflow-auto"
          style={{
            borderBottomRightRadius: ".625rem",
            borderBottomLeftRadius: ".625rem",
          }}
        >
          <table className="table mb-0">
            <thead className="bg-light">
              <tr>
                <th scope="col" className="border-0">
                  #
                </th>
                <th scope="col" className="border-0">
                  E-mail
                </th>
                <th scope="col" className="border-0">
                  Référence
                </th>
                <th scope="col" className="border-0">
                  Total 30D
                </th>
                <th scope="col" className="border-0">
                  Erreur 30D
                </th>
                <th scope="col" className="border-0">
                  % Erreur
                </th>
              </tr>
            </thead>
            <tbody>
              {this.props.data.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.email}</td>
                  <td>{item.reference}</td>
                  <td>
                    <span>{item.total}</span>
                  </td>
                  <td>
                    <span>{item.error}</span>
                  </td>
                  <td>
                    <span
                      className={
                        item.error_rate > 5 ? "text-danger" : "text-success"
                      }
                    >
                      {item.error_rate}%
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </CardBody>
      </Card>
    );
  }
}
